/* ==========================================================================
Javascript | ILM                                         
Author: Matt O'Neill, Codehouse Group Ltd
========================================================================== */
var blockGeoSearch = false;
var geoCodeSuccess = false;

/* ============================================
Viewport and User Agent detection
=============================================== */
var mobileUser = false;
if( /Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent) ) {
    mobileUser = true;
    $('html').addClass('mobile-user');
}
var navAgent = navigator.userAgent.toLowerCase(),
    isIE = /msie|rv:11/i.test(navAgent),
    isIE8 = navAgent.indexOf('msie 8.0') > -1;

/* ============================================
Web forms for marketers construction & helpers
=============================================== */
function runWebFormsConstructor() {
    
    // TODO: WFFM CHECK

    /* ----------------------------------
    Generic features 
    ---------------------------------- */

    if ($('.scfForm').length) { //IF THERE IS A FORM PRESENT

        $('.scfForm').each(function () { //THIS SOLVES THE ISSUE OF HAVING MULTIPLE SCFFORMS PER PAGE

            var thisForm = $(this);
            if (!$(thisForm).hasClass('setup-complete')) {

                /* Tooltip insertion */
                var scfTooltipsContentContainer,
                    scfTooltipsContent,
                    inputTypes = '.scfDropListUsefulInfo, .scfSingleLineTextUsefulInfo, .scfMultipleLineTextUsefulInfo, .scfEmailUsefulInfo, .scfCheckBoxListUsefulInfo';

                //Based on presence of tooltip text per input, assign a tooltip icon to section

                thisForm.find($('#content .scfSectionContent').children('div')).each(function () {
                    scfTooltipsContentContainer = $(this).children('div').find(inputTypes);
                    scfTooltipsContent = scfTooltipsContentContainer.text();
                    if (scfTooltipsContent.length) { //each section with a tooltip
                        $('<div class="scfTooltip scfTooltip-enabled"><div class="scfTooltip-balloon"><div class="scfTooltip-balloon-inner">' + $(this).find(inputTypes).html() + '</div></div></div>').insertAfter($(this).children('div'));
                        $(inputTypes).hide();
                    }
                });

                /* Hover trigger */
                $('.scfTooltip-enabled').hover(
                    function () { $(this).addClass("show"); },
                    function () { $(this).removeClass("show"); }
                );

                /* ----------------------------------
                Form specific features 
                ---------------------------------- */
                //Detect error message mode (innerControl or not)

                var innerControl = thisForm.find($('.scfValidatorRequired')).hasClass('inner.1'); //establish which control types is being used, inner/ or not

                //If NOT inner control, hide the validators and display the summary at the top, 
                if (!innerControl) {
                    //hide inline validators
                    thisForm.find($('.scfValidatorRequired')).css('position', 'absolute');
                    thisForm.find($('.scfValidatorRequired')).css('visibility', 'hidden');
                }

                //Add controls
                var numberOfSections = thisForm.find($('.scfSectionContent')).size();
                var controlString = '<div class="controls"><div class="left-col"></div><div class="right-col"></div></div>',
                    previousButton = '<span class="cta previous-button"><< Previous</span>',
                    nextButton = '<span class="cta next-button">Next >></span>',
                    submitButton = thisForm.find($('.scfSubmitButtonBorder')),
                    activeIndex = 0; //Set when each index is active

                var indexItem;
                //set up placeholder for controls
                $(controlString).insertAfter(thisForm.find($('.scfSectionContent')));

                //If there are more than 1 sections
                if (thisForm.find($('.scfSectionContent')).length > 1) {

                    //Remove fieldset bottom border for multiples
                    //            $('.scfForm .scfSectionBorderAsFieldSet').css('border-bottom', 'none');

                    // Add arrow span
                    thisForm.find($('.scfSectionLegend')).append('<span class="direction down"></span>');

                    //Two stage forms add buttons
                    thisForm.find($('.scfSectionContent')).each(function () {
                        indexItem = $(this).parents('fieldset').parent().index();
                        //For first and last sections
                        switch (indexItem) {
                            case 0:
                                //First Section
                                $(this).parent().find('.right-col').html($(nextButton));
                                break;
                            case numberOfSections - 1:
                                //Final section
                                $(this).parent().find('.left-col').html($(previousButton));
                                submitButton.remove(); //remove it
                                $(this).parent().find('.right-col').html($(submitButton)); //Move submit button to last section
                                break;
                        }

                        //or sections in between
                        if (indexItem > 0 && indexItem < numberOfSections - 1) {
                            $(this).parent().find('.left-col').html($(previousButton));
                            $(this).parent().find('.right-col').html($(nextButton)); //Move submit button to last section
                        }
                    });
                }
                //Else just position submit button where next would go...
                else {
                    thisForm.find($('.scfSectionContent')).parent().find('.right-col').html($(submitButton)); //Move submit button to last section
                    thisForm.css('border', 'none');
                    //$('.scfForm .scfSectionBorderAsFieldSet').css('border', '1px solid #cbcbcb');
                }

                //Form variable elements
                var contentExceptLegend = thisForm.children().children().find('.scfSectionContent'); //get Content
                var sectionControls = thisForm.children().children().find('.controls'); //get Controls
                var sectionArrow = thisForm.children().children().find('.scfSectionLegend').children('span'); //item Arrow
                var clickIndex; //index of clicked elements 

                //RESET () Show first step

                function formReset() {
                    contentExceptLegend.add(sectionControls).hide(); //Hide Content
                    contentExceptLegend.eq(0).show(); //Show Content
                    sectionControls.eq(0).show(); // Show Controls
                    sectionArrow.eq(0).toggleClass('down'); // Set state arrow
                }

                //RESET INVALID () If for is invalid, ie. fails client validation on submit;
                //reset and open step with first invalid field in, as opposed to just first step

                function formInvalidReset() {
                    var invalidField = thisForm.find('.scfInvalid').first();
                    var invalidFieldParent = invalidField.parents('.scfSectionContent');
                    var invalidFieldParentIndex = invalidFieldParent.parent('.scfSectionBorderAsFieldSet').parent().index();
                    contentExceptLegend.add(sectionControls).hide(); //Hide Content
                    contentExceptLegend.eq(invalidFieldParentIndex).show(); //Show Content
                    sectionControls.eq(invalidFieldParentIndex).show(); // Show Controls
                    sectionArrow.eq(invalidFieldParentIndex).toggleClass('down'); // Set state arrow
                }

                //Button functions 
                function collapseToggle(linkObj, clickIndex) {
                    contentExceptLegend.add(sectionControls).slideUp(); //Hide Content
                    contentExceptLegend.eq(clickIndex).add(sectionControls.eq(clickIndex)).slideDown(); //Show NEXT Content
                    sectionArrow.eq(clickIndex).add(sectionArrow.eq(activeIndex)).toggleClass('down'); // Toggle state arrow
                    activeIndex = clickIndex;
                }

                ;
                //Button Triggers
                thisForm.find($('.previous-button')).click(function () {
                    clickIndex = $(this).parents('fieldset').parent().index(); //Get index
                    contentExceptLegend.eq(clickIndex).add(sectionControls.eq(clickIndex)).slideUp(); //Hide Content
                    contentExceptLegend.eq(clickIndex - 1).add(sectionControls.eq(clickIndex - 1)).slideDown(); //Show NEXT Content
                    sectionArrow.eq(clickIndex).add(sectionArrow.eq(clickIndex - 1)).toggleClass('down'); // Toggle state arrow
                    activeIndex = clickIndex - 1;
                });
                thisForm.find($('.next-button')).click(function () {
                    clickIndex = $(this).parents('fieldset').parent().index(); //Get index
                    contentExceptLegend.eq(clickIndex).add(sectionControls.eq(clickIndex)).slideUp(); //Hide Content
                    contentExceptLegend.eq(clickIndex + 1).add(sectionControls.eq(clickIndex + 1)).slideDown(); //Show NEXT Content
                    sectionArrow.eq(clickIndex).add(sectionArrow.eq(clickIndex + 1)).toggleClass('down'); // Toggle state arrow
                    activeIndex = clickIndex + 1;
                });
                thisForm.find($('.scfSectionLegend')).click(function () {
                    clickIndex = $(this).parents('fieldset').parent().index(); //Get index
                    if (activeIndex != clickIndex) {
                        collapseToggle($(this), clickIndex);
                    }
                });

                /* --------------------------
                Required field helper 
                ----------------------------- */
                //For each field on the form
                //thisForm.find($('.scfSectionContent')).children('div').each(function () {
                //    /* Required Fields FAILED */
                //    if ($(this).find('.scfValidatorRequired').css('display') == "inline") { // if true
                //    }
                //});

                /* --------------------------
                check for empty (required)
                ----------------------------- */

                function emptyCheck() {
                    //For each requried field validator (which are hidden)
                    thisForm.find($('.scfValidatorRequired')).each(function () {
                        $(this).val($(this).attr("data-watermark"));
                        if ($(this).css('display') != "none") {
                            $(this).parent().find('input').addClass('scfInvalid');
                            $(this).parent().find('.styled-dropdown').addClass('scfInvalid');
                            //$(this).parent().find('input').attr("placeholder", 'This field is required'); //HTML5 placeholder for required
                        } else {
                            $(this).parent().find('input').removeClass('scfInvalid');
                            $(this).parent().find('.styled-dropdown').removeClass('scfInvalid');
                        }
                    });
                }
                /* --------------------------
                custom date validation
                ----------------------------- */
                function customDateValidationSubmit(passObj) {
                    passObj.find('.date-dropdowns').each(function () {
                        if ($(this).find('.scfInvalid').length) {
                            $(this).find('.scfInvalid').each(function () {
                                $(this).parents('.date-dropdowns').children('div.dropdown-widget').addClass('scfInvalid');
                            });
                        }
                    });
                }

                /* --------------------------
                on Submit Validation helper
                ----------------------------- */
                thisForm.find($('.scfSubmitButtonBorder input')).click(function () { //user clicks submit button
                    emptyCheck(); //Check for invalid, provided by WFFM
                    thisForm.find($('.scfSectionContent')).each(function () {
                        //custom date dropdowns exception
                        if ($(this).find('.date-dropdowns').length) {
                            customDateValidationSubmit($(this));
                        };

                        if ($(this).find('.scfValidatorRequired').length) { // if true
                            formInvalidReset(); //Reset the form if invalid 
                        }
                    });
                    if (innerControl) { //If inner control, hide validation summary as messages are inline
                        thisForm.find($('.scfValidationSummary')).hide();
                    }
                });

                /* --------------------------
                Form disabled element disable
                ----------------------------- */
                //Hidden on empty fields
                thisForm.find('.hidden-on-empty').each(function () {
                    if ($(this).find('input[type="text"]').val() == "" || $(this).find('input[type="text"]').val() == "undefined") {
                        $(this).hide();
                    }
                    else {
                        $(this).find('label').hide();
                        $(this).addClass('disable');
                    }
                });

                //Disabled fields (relies on the above function - hidden on empty - to assign the disabled class)
                thisForm.find('.disable').children().children('input').attr('disabled', "disabled");

                /* --------------------------
                Date Picker Customisation
                ----------------------------- */
                //                var yyyymmddRegEx = new RegExp(/^(0?[1-9]|[12][0-9]|3[01])[\/\-](0?[1-9]|1[012])[\/\-]\d{4}$/),
                //                 dateValid;
                //                var today = new Date();
                //                var dd = today.getDate();
                //                var mm = today.getMonth() + 1; //January is 0!
                //                var yyyy = today.getFullYear();
                //                if (dd < 10) { dd = '0' + dd } if (mm < 10) { mm = '0' + mm } today = (yyyy - 16) + '-' + mm + '-' + dd;
                //                thisForm.find('.scfDatePickerGeneralPanel').each(function () {
                //                    var thisDatePicker = $(this).children('input');
                //                    //Remove the readonly attribute on focus
                //                    thisDatePicker.focus(function () {
                //                        $(this).removeAttr('readonly');
                //                    });
                //                    //Validation Functions
                //                    function dateValidate() {
                //                        switch (dateValid) {
                //                            case true:
                //                                thisDatePicker.removeClass('scfInvalid');
                //                                break;
                //                            case false:
                //                                thisDatePicker.addClass('scfInvalid');
                //                                break;
                //                        }
                //                    };
                //                    //Add blur validation controls
                //                    thisDatePicker.blur(function () {
                //                        dateValid = yyyymmddRegEx.test($(this).val()); //Test against the regex
                //                        dateValidate(); //check valid
                //                    });
                //                    //Focus on date picker clear validation
                //                    $('.ui-datepicker-calendar').live('focus', function () {
                //                        thisDatePicker.removeClass('scfInvalid');
                //                    });
                //                    //                    $(function() {
                //                    //                       $('.scfDatePickerTextBox').datepickerdate();
                //                    //                       $('.scfDatePickerTextBox').datepickerdate('setDate', today);
                //                    //                    });
                //                });

                // Init form
                formReset();
                $(thisForm).addClass('setup-complete');

            } //If this form hasn't already been setup or affected by a postback 

       });              //For each form
            
    };//If length


} //end of webforms constructor()

// TODO: WFFM CHECK
runWebFormsConstructor();

$(document).ready(function () {
    
    // TODO: WFFM CHECK

    // Remove issue with WFFM that permanently disables submit button
    setTimeout(function () { // needs to be in a settimeout otherwise it binds before the WFFM javascript is applied
        $('.RadEditor').find('.reContentArea').focus(function () {
            $(this).parents('.scfSectionContent').next('.controls')
                .find('.scfSubmitButtonBorder input[type="submit"]').removeAttr('disabled');
        });
    });

    //Navigator, hide border element before
    $('.primary-nav .active').prev().css('border-right', 'none');

    /* ================================
    Lighbox
    ================================ */
    //Trigger
    $('.lightbox-trigger').click(function () {
        $('.lightbox').fadeIn(600);
        $('.lightbox-bg').fadeIn(600);
        $('html').addClass('no-scroll'); //stop scroll when lightbox present
    });
    //Close
    $('.lightbox-bg, .lightbox .close, .close-qual-builder').click(function (e) {
        if (e.target === this) {
            $('.lightbox').fadeOut(600);
            $('.lightbox-bg').fadeOut(600);
            $('html').removeClass('no-scroll'); //stop scroll when lightbox present
        }
    });
    /* Qualification lightbox */
    $('.qual-builder').click(function (e) {
        var lightboxHeight = $('.qualification-lightbox .lightbox-content').height();
        e.preventDefault(); //MON 21/03/2013 attempt to stop onward link
        $('.qualification-lightbox').fadeIn(600);
        $('.qualification-lightbox').css({ 'max-height': $(window).height() / 1.3, 'overflow-y': 'auto' });
        if (/ipad/i.test(navigator.userAgent.toLowerCase())) { // keep scroll enabled on ipad
        } else {
            $('html').addClass('no-scroll'); //stop scroll when lightbox present
        }
        $('.lightbox-bg').fadeIn(600, function () { });
        formatLightboxForScreenSize();
        $('.scrollbar-qualification-builder').tinyscrollbar();
        return false;
    });

    /* Comment form lightbox */
    var loggedInUser = $('#userLoggedInField').val() == 'true';
    $('.comment-form-show').click(function () {
        //move cta text() to lightbox <h3>
        var buttonText = $(this).text();
        var redirectUrl = $('#redirectUrlField').val();

        if (loggedInUser) {
            $('.comment-lightbox').children().children('h3').text(buttonText);
            $('.comment-lightbox').fadeIn(600);
            $('.lightbox-bg').fadeIn(600);
            return false;
        } else {
            window.location.href = redirectUrl;
            return false;
        }
    });

    if (window.location.href.indexOf('showlightbox=1') > -1 && loggedInUser && window.location.hash.indexOf('comment') == -1) {
        if ($('.comment-form-show').length) {
            $('.comment-form-show').trigger('click');
            window.location.hash = "comment";
        }
    }

    //disable scroll if "no-scroll," for lightbox
    document.ontouchmove = function (e) {
        if ($('html').hasClass('no-scroll')) {
            e.preventDefault();
        }
        else {
            //
        }
    };


    /* ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ */

    /* ================================
    My Profile
    ================================ */
    //Show

    $('.my-profile-tab').click(function (e) {
        if (!$(e.target).hasClass('different-user')) {
            if ($('.my-profile').length) {  //If present on page (logged in)
                $('.my-profile').slideToggle(500, "easeInOutQuad"); //Show membership details screen
            } else {
                $('.white-mask').fadeOut(200);
                $('.login-register').slideToggle(500, "easeInOutQuad"); //Else: Slide login/register boxes
            }
        }
    });

    /* ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ */


    /* ================================
    Mega Drop-down (with slip control)
    ================================ */
    var primaryNav = $('.primary-nav'),
            primaryLevelItem = $('.primary-nav > ul > li'),
            dropDown = $('.mega-dropdown'),
            secondLevelItem = $('.mega-dropdown .second-level').children(),
            definiteSelection = false, //for timer handling, stops unwanted triggering
            selectionTimer, //Timer variable for defininte selections
    // selectedNavIndex,
            isInside = false, //For slip control
            animationTransition = false, //for animation interruption transition
            slipTimer; //Slip timer variable 

    function showNavChildren(selectedNavIndex) {

        animationTransition = true;
        secondLevelItem.eq(selectedNavIndex).show();
        dropDown.show();

    };
    function hideNavChildren() {
        secondLevelItem.hide();
        dropDown.hide();
    };

    $('.primary-nav > ul > li').mouseenter(function () {
        var selectedNavIndex = $(this).index();
        definiteSelection = true;
        //check for children
        selectionTimer = setTimeout(function () {
            if (definiteSelection) {
                if (secondLevelItem.eq(selectedNavIndex).children().length) {
                    secondLevelItem.hide();
                    showNavChildren(selectedNavIndex);
                } else {
                    hideNavChildren();
                }
            }
        }, '150');
    });
    primaryLevelItem.mouseleave(function () {
        definiteSelection = false;
    });


    //Enter Nav with Slip Timer
    primaryNav.mouseenter(function () {
        isInside = true;
    });
    //Leave Nav with Slip Timer
    primaryNav.mouseleave(function () {
        isInside = false;
        if (!isInside) {
            hideNavChildren();
        }
    });

    /* ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ */

    $('#fader-button').click(function () {
        if (nowClickable) {
            return true;
        }
        else {
            return false;
        }
    });


    /*tool tips */
    if ($('div.tooltip').length) {
        $('div.tooltip').each(function (index) {
            $(this).addClass('tooltip-enabled');
            $(this).prepend('<div class="tooltip-balloon"><div class="tooltip-balloon-inner">' + $(this).find('span').html() + '</div></div>  ');
            $(this).hover(
					function () { $(this).addClass("show"); },
					function () { $(this).removeClass("show"); }
				);
        });
    }

    /* ------------------------------
    Info Box Text slide
    ------------------------------ */
    if ($('.image-segment').length) {
        $('.image-segment').hover(function () {
            $(this).find('.text').slideToggle(300);
        });
    }

    /*tabbed content*/

    //todo initial, read query
    //todo, after: read hash

    //new query parsing search 
    var queries = {}; //global queries array
    $.each(document.location.search.substr(1).split('&'), function (c, q) {
        var f = q.split('=');
        if (this.length) {  //if a query 
            queries[f[0].toString()] = f[1].toString(); // get string 
        }
        else {
            queries = { tab: 1 };   // tab set to first item
        }
    });

    if ($('div.tabberContainer').length) {
        $('div.tabberContainer').each(function (index) {
            //find h3's in .tabberItem and use this to generate and unordered list.
            var tabbernav = '';
            $(this).find('.tabberItem h3').each(function (index) {
                var text = $(this).text();

                var anchor = text.toLowerCase().replace(/\s/g, ''); //For multiple whitespace replacement, a regEx is required
                $(this).parent().addClass(anchor);
                $(this).hide();
                tabbernav += '<li class="' + anchor + '-tab"><a href="#' + anchor + '">' + $(this).text() + '</a></li>';
            });
            $(this).prepend('<ul class="tabberNav">' + tabbernav + '</ul>');

            var initalSelectedIndex = 0;
            var listItem = $('.' + queries.tab + '-tab'); //put tab query string as class
            var index = $(this).find('.tabberNav li').index(listItem); //find index of class in tabber

            if (index > 0) {
                initalSelectedIndex = index; //set to initial load, 1,2,3
            }

            //set initial hidden and anctive states - showing only the first tab
            $(this).find('.tabberItem').each(function (index) {
                if (index != initalSelectedIndex) $(this).hide();
            });

            $(this).find('.tabberNav li').each(function (index) {
                if (index == initalSelectedIndex) $(this).addClass('active');
            });

            //tab - click event handler
            $(this).find('.tabberNav li a').click(function () {
                if (!$(this).parent().hasClass('active')) {
                    var $tabberItems = $(this).parents('.tabberContainer').find('.tabberItem'),
                        $matchingTabberItem = $tabberItems.eq($(this).parent().index());

                    // remove all parent .active and set this parent to .active
                    $(this).parent().parent().find('li.active').removeClass('active');
                    $(this).parent().addClass('active');

                    // hide all .tabberItems and show only active one
                    $tabberItems.hide();
                    $matchingTabberItem.show();
                    $matchingTabberItem.find('.scrollbar-qualification-builder').tinyscrollbar(); //Init scroll bar for section (qual builder)
                    $matchingTabberItem.find('.guides-resources-scrollbar').tinyscrollbar(); //Init scroll bar for section  (guides resources)
                }
            });
        });
        if ($('div.tabberContainer').find('.guides-resources-scrollbar').length) {
            $('div.tabberContainer').find('.guides-resources-scrollbar').each(function () {
                $(this).tinyscrollbar(); //init scrolls on load
            });
        }
    }
    /* ===================================
    Qualification Builder
    ====================================== */
    if ($('.qualification-builder').length) {
        qualificationBuilder();
    }

    //~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~

    /* ------------------------------
    Learning and Development rotator
    --------------------------------- */

    //if ($('section.carousel-landd').length) {

    //    //functionality is to be hidden from view if javaScript is not enabled
    //    $('section.carousel-landd').css('display', 'block');

    //    var $roundAbout = $('section.carousel-landd ul.roundabout');
    //    $roundAbout.roundabout({
    //        btnNext: ".ra-move-right",
    //        btnPrev: ".ra-move-left",
    //        maxScale: 1,
    //        minScale: 0.2,
    //        tilt: 1,
    //        minOpacity: 1
    //    });

    //    //Call to action for item in focus
    //    $('section.carousel-landd .roundabout-moveable-item').click(function () {
    //        if ($(this).hasClass('roundabout-in-focus')) {
    //            window.location = $(this).attr('rel');
    //        }
    //        else {
    //        }
    //    });
    //}


    //~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~

    /* ================================
    Minimised header mode, onload
    ================================ */
    if ($('#insight, .insight-article').length) {
        $('#mode-switcher').addClass('header-mode');
    }
    /* ================================
    Header Mode Switch
    ================================ */
    $('#switch').click(function () {
        $('#mode-switcher').removeClass('header-mode');
    });


    //~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~

    /* ============================
    Looking for change
    =============================== */
    $('.looking-for').change(function () {
        var lookingForValue = $(this).val();
        if (lookingForValue == -1) {
            $('.postcode-code-input').fadeOut();
        }
        else {
            $('.postcode-code-input').fadeIn();
        }
    });


    /* =====================================
    Qualification Finder Promotional Segment
    ======================================== */
    //If element in question exists on page
    if ($('.qualification-finder.tabberContainer .promotional-segment').length) {
        var organisationSize,
                numberOfPeople;
        $('.organisation-size, .number-of-people').change(function () {

            hiddenOrganisationSize = $('#orgSizePromoBoxValue').val();
            hiddenNumOfPeopleSize = $('#numOfPeoplePromoBoxValue').val();

            organisationSize = $('.organisation-size').val(); //Selection value
            numberOfPeople = $('.number-of-people').val(); //Selection value

            var selectionState = {
                A: organisationSize == hiddenOrganisationSize || numberOfPeople == hiddenNumOfPeopleSize, //If either are over threshold
                B: organisationSize != hiddenOrganisationSize && numberOfPeople != hiddenNumOfPeopleSize  //If both are under threshold
            };
            //If one if over threshold
            if (selectionState.A == true) {
                $('.qualification-finder.tabberContainer .promotional-segment').fadeIn();
            }
            //If both only are under threshold
            if (selectionState.B == true) {
                $('.qualification-finder.tabberContainer .promotional-segment').fadeOut();
            }
        });
    }

    /* =========================================
    Toggle arrow clicks (qualification results)
    ============================================ */
    $('.collapse-module header').click(function () {
        $(this).find('.toggle-arrow').toggleClass('up');
        $(this).parent().find('.details').slideToggle(500, 'easeInOutSine');
    });
    $('.course-details .collapse-module .details').hide();

    /* =========================================
    View-more (centre results)
    ============================================ */
    $('.view-more-trigger a').click(function (e) {
        $(this).parent().siblings('.centre-more-info').toggle();
        $(this).text($(this).text() == 'Show more' ? 'Show less' : 'Show more');

        e.preventDefault();
        //$(this).children('.more').toggle();
    });

    /* =================================
    Geo-Code-Search (button)
    ==================================== */
    $('.geo-code-search').click(function () {
        var button = $(this);
        //button.addClass('clicked');
        if (!blockGeoSearch) {
            //eval(this);
            return true;
        }
        return false;
    });


    /* ================================
    Scrollbar
    ================================ */
    if ($('#scrollbar1').length) {
        //$('#scrollbar1').tinyscrollbar();
    }

    if ($('#scrollbar-vertical').length) {  //Half width scrollbar vertical
        $('#scrollbar-vertical').tinyscrollbar();
    }

    //        if ($('#scrollbar-qualification-builder').length) { 
    //            $('#scrollbar-qualification-builder').tinyscrollbar();
    //        }

    if ($('#guides-resources-scrollbar').length) {
        $('#guides-resources-scrollbar').tinyscrollbar();
    };

    if ($('#scrollbar-horizontal').length) {  //Half width scrollbar horizontal

        // For horizontal, set width of content before init scrollbar (allows dynamic adjustment)
        var scrollItemContainer = $('#scrollbar-horizontal').find('.overview'),
                scrollItemCount = $('#scrollbar-horizontal').find('.overview').children('article').size(),
                itemWidth = $('#scrollbar-horizontal').find('.overview').children('article').width(); //TODO, IE8 Support

        scrollItemContainer.css('width', scrollItemCount * itemWidth); // set width
        $('#scrollbar-horizontal').tinyscrollbar({ axis: 'x' }); //init scrollbar
    }

    /* Querystring parsing code */
    var querystring = location.search.replace('?', '').split('&');
    var queryObj = {};

    // loop through each name-value pair and populate object
    for (var i = 0; i < querystring.length; i++) {
        // get name and value
        var name = querystring[i].split('=')[0];
        var value = querystring[i].split('=')[1];
        // populate object
        queryObj[name] = value;
    }
    var pageEditorMode;
    if (querystring[0] == "sc_mode=edit") {
        pageEditorMode = true;
    }
    var previewMode;
    if (querystring[0] == "&sc_mode=preview") {
        previewMode = true;
    }

    //Force login mode
    var loginQuery;
    if (querystring.indexOf("login=1") != -1) {
        forceLoginMode();
    }

    /* On blur, getGeoCode information */
    $('input.geocode-target').blur(function () {
        getGeoCode($(this).val(), $('input.geocode-container'));
    });

    /* --------------------------
    Video Hover Title
    ----------------------------- */
    /*
    var videoHoverActive = false;
    $('#page').on('mouseenter', '.youtube-wrapper, .video-module', function () {
        var thisVideoInstance = $(this);
        var videoHoverTimer = setTimeout(function () {
            if (videoHoverActive) {
                thisVideoInstance.children('.title').show();
                thisVideoInstance.children('.info-box').slideDown();
            }
        }, '200');
        videoHoverActive = true;
    });

    $('#page').on('mouseleave', '.youtube-wrapper, .video-module', function () {
        videoHoverActive = false;
        $(this).children('.title, .info-box').slideUp(430, "swing");
    });


    $('.video-module iframe').each(function () { //each rte inserted youtube snippet
        var thisSrc = $(this).attr('src');              //get source
        var thisVideoTitle = $(this).attr('title');     //get title
        var appendParams = thisSrc + "?showinfo=0&autohide=1&rel=0&wmode=opaque&showinfo=0";    //set params
        $(this).attr('src', appendParams);  //append params
        $(this).parent().append('<div class="info-box"><h2>' + thisVideoTitle + '</h2></div>');
    });
    */

    //youtube videos created in the rich text editor


    /* -----------------------------------------------------------------------
    Multiple page forms (Only required once - outside webforms constructor)
    ----------------------------------------------------------------------- */
    //For forms which are spread over multiple pages, when mulitple SAP calls are required
    if ($('.form-steps').length) {
        var progressBarWidth = $('.form-progress-bar').width(),
            stepsCount = $('.form-steps li').size(), //To determine widths of each cell division
            percentageWidths = progressBarWidth / stepsCount, //Percentage width fractions
            formStageWidth = percentageWidths; //Based on percentage calculation

        var activeStep = $('.form-steps li.active'),
            activeStepPosition = activeStep.index() + 1; //To determine how many LIs should be set active...

        for (i = 0; i < stepsCount; i++) {
            $('.form-progress-bar').append('<span class="stage"></span>');
        }
        //Set CSS widths to each stage
        $('.stage').css('width', formStageWidth - 2);

        //Set active loop | Active to each stage less than activeStepPosition.value
        for (i = 0; i < activeStepPosition; i++) {
            $('.form-progress-bar > span').eq(i).addClass('active');
        }
        //Assign current/total steps ticker
        $('.form-progress span.current').text(activeStepPosition);
        $('.form-progress span.total').text(stepsCount);
    }

    /* youtube helper wmode */
    //    if($('iframe').length)
    //    {
    //        $('iframe').each(function() {
    //            var iframeSrc = $(this).attr('src'), 
    //                instanceLocation = iframeSrc.search("www.youtube.com");
    //            
    //            if(instanceLocation != "-1") {
    //                $(this).attr('src' ,iframeSrc +'?wmode=opaque');
    //            }
    //        });
    //    }

    $('#txtPostCode').focus(function () {
        if ($(this).val() == 'Post code') {
            $(this).val('');
        }
    });
    /*
    $('#txtPostCode').blur(function () {
        if ($(this).val() == '') {
            $(this).val('Post code');
        }
    });
    */
    $('.primary-nav .search input[type="text"]').focus(function () {
        if ($(this).val() == 'Search...') {
            $(this).val('');
        }
    });
    $('.primary-nav .search input[type="text"]').blur(function () {
        if ($(this).val() == '') {
            $(this).val('Search...');
        }
    });

    /* youtube community wmode */
    $('.scroll-module iframe').each(function () {
        var youtubeurl = "www.youtube.com";
        var thisSrc = $(this).attr('src');
        var isyoutube = thisSrc.search(youtubeurl);
        var question = "&#063;";
        var isquery = thisSrc.search(question);
        var appendString = "";
        if (isquery > 0) {
            appendString = "&wmode=transparent";
        } else {
            appendString = '?wmode=transparent';
        }
        if (isyoutube > 0) {
            thisSrc = thisSrc + appendString;
        }
        $(this).attr('src', thisSrc);
    });

    //Article height leveling
    var articleHeight = [];
    $('.columns-50').find('article').each(function () {
        articleHeight.push($(this).height());
    });

    var largest = Math.max.apply(Math, articleHeight);

    $('.columns-50').find('article').css('height', largest);


    //AT register

    if ($('#event-location').length) {
        var geocoder,
            map,
            position,
            marker,
            address = $('#venuegeolocation').val(),
            infowindowAddress = $('#venuelocation').val().replace(new RegExp(', ', 'g'), '<br>');

        function createEventMarker(position) {
            marker = new google.maps.Marker({
                map: map,
                position: position
            });

            map.setCenter(position);

            var infowindow = new google.maps.InfoWindow({
                content: infowindowAddress
            });

            google.maps.event.addListener(marker, 'click', function () {
                infowindow.open(map, marker);
            });
        }

        function renderEventMap() {
            var mapOptions = {
                zoom: 14,
                mapTypeId: google.maps.MapTypeId.ROADMAP
            }
            map = new google.maps.Map(document.getElementById("event-map"), mapOptions);            

            if ($('#uselatitudeandlongitude').val() == 'true') {
                var posArray = address.split(',');

                createEventMarker(new google.maps.LatLng(posArray[0], posArray[1]));                
            }
            else {
                geocoder = new google.maps.Geocoder();
                geocoder.geocode({
                    'address': address
                }, function (results, status) {                    
                    if (status == google.maps.GeocoderStatus.OK) {
                        createEventMarker(results[0].geometry.location);
                    }
                });
            }
            
            $('#event-directions a').click(function (e) {
                e.preventDefault();
                window.open('https://www.google.com/maps/dir/' + $('#event-directions-input').val() + '/' + address);
            });

            $('#event-directions-input').keyup(function (e) {
                if (e.keyCode == 13) {
                    window.open('https://www.google.com/maps/dir/' + $('#event-directions-input').val() + '/' + address);
                }
            });
        }

        renderEventMap();
    }

});                                        //DOM Ready

$(window).on("load", function (e) {
    $('.bottom-links').css('margin-bottom', $('.footer-logo img').height() / 1.75);
});

//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
/* --------------------------------
Cater for scroll on smaller screens
-------------------------------- */
var qualLightbox = $('.qualification-lightbox');

//$(window).resize(function () {
//    formatLightboxForScreenSize();
//});
var smallScreen = false;
//todo if not iPad/iPhone?
function formatLightboxForScreenSize() {
    var lightboxHeight = $('.qualification-lightbox .lightbox-content').height();
    var windowHeight = $(this).height();
    if (windowHeight < lightboxHeight) { //if window becomes smaller than lightbox, init overflow case
        //qualLightbox.css('height', '430px');
        qualLightbox.addClass('small-screen');
        //qualLightbox.css('overflow-y', 'scroll');
    } else {
        //qualLightbox.css('overflow-y', 'hidden');
        qualLightbox.removeClass('small-screen');
        //qualLightbox.css('height', 'auto');
    }
}
/* Functions */
/* 
   ---------------------------------------
   Qualification Builder
   --------------------------------------- */
function qualificationBuilder() {

    var selectionID, stage = 1; //default stage is stage 1

    /* Drag and drop */
    if (!mobileUser) {
        var $remove = $(".remove"),
            $draggable = $(".options li"),
            $droppable = $(".chosen-options ol"),
            insideHTML;

        $draggable.draggable({
            appendTo: "#scrollbar-qualification-builder",
            helper: "clone",
            start: function (event, ui) {
                //Start dragging
            }
        });

        $droppable.droppable({
            activeClass: "ui-state-default",
            hoverClass: "ui-state-hover",
            accept: ":not(.ui-sortable-helper)",
            drop: function (event, ui) {
                insideHTML = ui.draggable.html();
                $(this).find(".placeholder").remove();
                $("<li></li>").html(insideHTML).appendTo(this).attr('id', ui.draggable.attr('id')).attr('rel', ui.draggable.attr('rel')); //Append to list (DROP)
                $(this).parents('.drag-drop-module').find($('.chosen-options h4').addClass('top-reset')); //Move header to top
                $(this).parents('.drag-drop-module').find($('.chosen-options .table-headings')).fadeIn(); //Introduce table headings
                $(this).parents('.drag-drop-module').find($('.chosen-options ol li')).fadeIn(300);

                //ID control for disable       
                selectionID = ui.draggable.attr('id');
                disableSelected(selectionID, $(this).parents('.drag-drop-module')); //Run disable ID function
            }
        }).sortable({
            items: "li:not(.placeholder)",
            sort: function () {
                // gets added unintentionally by droppable interacting with sortable
                // using connectWithSortable fixes this, but doesn't allow you to customize active/hoverClass options
                $(this).removeClass("ui-state-default");
            }
        });

        // Remove the item if dropped in the remove zone
        $remove.droppable({
            accept: ".chosen-options li",
            activeClass: "ui-state-highlight",
            drop: function (event, ui) {
                ui.draggable.remove();
                //ID control for RE-ENABLE    
                selectionID = ui.draggable.attr('id');
                enableSelected(selectionID, $(this).parents('.drag-drop-module')); //Run disable ID function
                //Reset if now empty
                if ($(this).parents('.drag-drop-module').find('.chosen-options ol li').size() == 1) {
                    $(this).parents('.drag-drop-module').find($('.chosen-options .table-headings')).fadeOut(250); //hide table headings
                    $(this).parents('.drag-drop-module').find($('.chosen-options .drag-box-text')).fadeOut(250, function () { //fade out h4
                        $(this).removeClass('top-reset'); //reset header to middle
                        $(this).fadeIn(250); //fade back in
                    });

                    //Insigate a "back" event if a) In stage 2, b) empty;
                    if (stage == 2) {
                        $('.back').click();
                    }
                };
            }
        });
    } //if !mobile user
    else {
        /* mobile click handling */
        //update drag text to select
        $('.drag-box-text').text("Select from left to add or from here to remove");
        //touch events (click)
        $('#page').on('click', '.options li', function (event, ui) {
            insideHTML = $(this).html();
            $("<li></li>").html(insideHTML).attr('id', $(this).attr('id')).attr('rel', $(this).attr('rel')).appendTo($(this).parents('.drag-drop-module').find($('.chosen-options ol')));
            $(this).parents('.drag-drop-module').find($('.chosen-options h4').addClass('top-reset')); //Move header to top
            $(this).parents('.drag-drop-module').find($('.chosen-options .table-headings')).fadeIn(); //Introduce table headings
            $(this).parents('.drag-drop-module').find($('.chosen-options ol li')).fadeIn(300);

            //ID control for disable
            selectionID = $(this).attr('id');
            disableSelected(selectionID, $(this).parents('.drag-drop-module')); //Run disable ID function
        });

        $('#page').on('click', '.chosen-options ol li', function () {
            $(this).fadeOut(function () {
                $(this).remove();
            });

            //ID control for RE-ENABLE    
            selectionID = $(this).attr('id');
            enableSelected(selectionID, $(this).parents('.drag-drop-module')); //Run disable ID function
            //Reset if now empty
            if ($(this).parents('.drag-drop-module').find('.chosen-options ol li').size() == 1) {
                $(this).parents('.drag-drop-module').find($('.chosen-options .table-headings')).fadeOut(250); //hide table headings
                $(this).parents('.drag-drop-module').find($('.chosen-options .drag-box-text')).fadeOut(250, function () { //fade out h4
                    $(this).removeClass('top-reset'); //reset header to middle
                    $(this).fadeIn(250); //fade back in
                });

                //Insigate a "back" event if a) In stage 2, b) empty;
                if (stage == 2) {
                    $('.back').click();
                }
            };

        });
    }

    /* -------------------------------------
    Clear selection button 
    -------------------------------------- */
    $('.qualification-builder .clear-all').click(function () {
        $('.checkboxes .check-widget-forms').children('span').removeClass('checked');
        $(this).parent().find($('.chosen-options ol li')).each(function () {
            selectionID = $(this).attr('id');
            enableSelected(selectionID, $(this).parents('.drag-drop-module')); //Run disable ID function
        });

        $(this).parents('.drag-drop-module').find($('.chosen-options .table-headings')).fadeOut(250); //hide table headings
        $(this).parent().find($('.chosen-options ol li')).fadeOut(250, function () {
            $(this).parents('.drag-drop-module').find($('.chosen-options .drag-box-text')).fadeOut(250, function () { //fade out h4
                $(this).removeClass('top-reset'); //reset header to middle
                $(this).fadeIn(250); //fade back in
            });
            $(this).remove();
        });
    });

    /* -------------------------------------
    Selected Elements Disable from Options 
    -------------------------------------- */
    /* Disables the element in the options section to stop duplicate additions */
    function disableSelected(selectionID, linkObj) {
        if (!mobileUser) {
            linkObj.find('.options').find('#' + selectionID).draggable("option", "disabled", true);
        }
        else {
            linkObj.find('.options').find('#' + selectionID).css('pointer-events', 'none');
            linkObj.find('.options').find('#' + selectionID).css('color', '#ccc');
        }
    };
    /* -------------------------------------
    Selected Elements Re-Enable from Options 
    -------------------------------------- */
    /* enables the element in the options section to stop duplicate additions */
    function enableSelected(selectionID, linkObj) {
        if (!mobileUser) {
            linkObj.find('.options').find('#' + selectionID).draggable("option", "disabled", false);
        }
        else {
            linkObj.find('.options').find('#' + selectionID).css('color', 'rgb(85,85,85)');
            linkObj.find('.options').find('#' + selectionID).css('pointer-events', 'all');

        }
    };

    /* --------------------------------
    Autocomplete 
    -------------------------------- */
    //Retrieve position of .options element, so that autocomplete can be overlaid

    $('input.autocomplete').each(function () {
        var thisElement = $(this),
                          fromList,
                          thisRel;
        $(this).autocomplete({
            minLeng: 3,
            source: function (request, response) { //source result of ajax
                $.ajax({
                    url: '/handlers/ilm/UnitsFilter.ashx',
                    data: { id: thisElement.attr('id'), term: request.term }, //pass id and search term
                    dataType: 'json',
                    success: function (data) { //map object to data
                        response($.map(data, function (item) {
                            return { label: item.Unit.Code + " - " + item.Unit.Title, value: item.ParentProduct.Code + '_' + item.Unit.Code }; //return label and value
                        }));
                    },
                    error: function (er) {
                    }
                });
            },
            open: function () {
                $(this).autocomplete('widget').css('z-index', 9999);
                return false;
            },
            select: function (event, ui) {
                $('.chosen-options ol').find(".placeholder").remove();
                $(this).parents('.drag-drop-module').find($('.chosen-options h4')).addClass('top-reset'); //Move header to top
                $(this).parents('.drag-drop-module').find($('.chosen-options .table-headings')).fadeIn(); //Introduce table headings
                fromList = $(this).parents('.drag-drop-module').find($('#' + ui.item.value)).html();    //Get the inner markup from element in options 
                thisRel = $(this).parents('.drag-drop-module').find($('#' + ui.item.value)).attr('rel'); //Get the description text (stored as rel)
                $("<li></li>").html(fromList).appendTo($(this).parents('.drag-drop-module').find($('.chosen-options ol'))).attr('id', ui.item.value).attr('rel', thisRel); //Add LI to chosend options, add ID to that LI
                $(this).parents('.drag-drop-module').find($('.chosen-options ol li')).fadeIn(300);

                //ID control for disable
                selectionID = ui.item.value;
                disableSelected(selectionID, $(this).parents('.drag-drop-module')); //Run disable ID function
            }
        });
    });

    /* --------------------------------
    Add all to qualification
    -------------------------------- */
    $('.add-all-units').click(function (e) {
        e.preventDefault();
        var $theQualificationBuilder = $(this).parents('.qualification-builder .tabberItem');
        $theQualificationBuilder.find('.qualification-builder .chosen-options ol.ui-droppable > li').remove();
        $theQualificationBuilder.find('.chosen-options .table-headings').show();
        $theQualificationBuilder.find('.chosen-options .drag-box-text').hide();
        $theQualificationBuilder.find('.drag-box-text, .your-selection').addClass('top-reset');
        $theQualificationBuilder.find('.options ul > li').each(function () {
            $(this).addClass('ui-draggable-disabled ui-state-disabled').attr('aria-disabled', 'true').clone().appendTo($theQualificationBuilder.find('.chosen-options ol.ui-droppable')).removeClass('ui-draggable ui-draggable-disabled ui-state-disabled').removeAttr('aria-disabled').show();
            $(this).draggable('disable');
        });
    });



    /* --------------------------------
    Create qualification (forward)
    -------------------------------- */
    function setPartSectionCheckbox($checkbox, part) {
        if (part.length) {
            var partValue = part.attr('class');
            var partChecked = partValue == "checked";

            $checkbox.prev('span').toggleClass('checked', partChecked);
            $checkbox.prop('checked', partChecked);
        }
    }

    var thisSection;

    $('.create-spec').click(function () {
        // If not empty
        thisSection = $(this).parents('.drag-drop-module');
        var thisSelection = $(this).parent().find($('.chosen-options ol li'));
        //ACTION
        if (thisSelection.length) { //If there are elements present          
            stage = 2;

            //reset checkboxes at final stage
            var $partACheckbox = thisSection.find('.checkboxes-selected').find('.part-A');
            var $partBCheckbox = thisSection.find('.checkboxes-selected').find('.part-B');

            $partACheckbox.prev('span').removeClass('checked');
            $partBCheckbox.prev('span').removeClass('checked');

            //set checkboxes
            thisSection.children('.left-column').children('.checkboxes').children('.segment').each(function () {

                var partA = $(this).find('.part-A').prev('span');
                var partB = $(this).find('.part-B').prev('span');

                setPartSectionCheckbox($partACheckbox, partA);
                setPartSectionCheckbox($partBCheckbox, partB);

            });

            $('.left-column').fadeOut(500, function () {

                var $rightColumn = thisSection.find('.right-column');
                var $chosenOptions = thisSection.find('.chosen-options');

                $('.tabberNav').slideUp(350);

                $rightColumn
                    .css({ float: 'right' })
                    .animate({ width: '100%' });

                $chosenOptions
                    .animate({ width: '100%' });

                //Refactor layout, add description to information
                thisSection.find($('.chosen-options ol')).animate({
                    width: '888px'
                });

                thisSection.find($('.chosen-options .title')).animate({
                    width: '700px'
                }, function () {
                    //Checkboxes in
                    thisSection.find($('.checkboxes-selected')).fadeIn(800, function () {

                    });
                });

                //removed MON 03/04/2013 Description 
                thisSection.find($('.chosen-options li')).each(function () {
                  //  $(this).children('.description').text("Description: " + $(this).attr('rel')).slideDown();
                });
            });

            //Button switching
            $(this).add($('.clear-all, .drag-box-text')).fadeOut(500, function () {
                $('.download-spec, .back, .your-selection').fadeIn();
            });
        } else {
            $('.none-selected').fadeIn(200, function () {
                $(this).fadeOut(1300);
            });
        }
    });

    /* --------------------------------
    Back
    -------------------------------- */

    $('.back').click(function () {

        stage = 1;

        thisSection
            .children('.right-column')
            .css({ width: '50%' });

        thisSection
            .find($('.chosen-options'))
            .animate({ width: '100%' }, function () {
                $('.left-column').fadeIn(500);
                $('.tabberNav').slideDown(350);
            });

        thisSection
            .find($('.chosen-options .description'))
            .slideUp();

        //Refactor layout, add description to information
        thisSection
            .find($('.chosen-options ol'))
            .animate({ width: '100%' });

        thisSection
            .find($('.chosen-options .title'))
            .animate({ width: '220px' });

        //Checkboxes out
        thisSection
            .find($('.checkboxes-selected'))
            .fadeOut(400);

        //Button switching
        $('.download-spec, .back, .your-selection')
            .fadeOut(function () {
                $('.clear-all, .create-spec, .drag-box-text').fadeIn();
            });

    });

    /* --------------------------------
    Checkboxes Change
    -------------------------------- */
    $('.checkboxes .check-widget-forms input').change(function () {
//        if ($(this).hasClass('part-A')) {
//            $('.checkboxes.selected .part-A').parent().children('span').toggleClass('checked');
//        };
//        if ($(this).hasClass('part-B')) {
//            $('.checkboxes.selected .part-B').parent().children('span').toggleClass('checked');
//        };
    });

    /* --------------------------------
    Hover description
    -------------------------------- */
    if (!mobileUser) {
        //Global vars 
        var topPos,
            descriptionRel,
            mouseInside = false,
            longtitle,
            activeElement;

        //enter the hit zone
        $('.options li').mouseenter(function () {
            mouseInside = true; //Set over
            activeElement = $(this);

            function showTip(activeElement) {
                if (mouseInside) { //Only if still over
                    if (!activeElement.hasClass('ui-draggable-disabled'))//If not disabled 
                    {

                        descriptionRel = activeElement.attr('rel'); //Get rel associated
                        longtitle = activeElement.children('.title').text(); //long title 
                        if (longtitle != "") {
                            topPos = activeElement.position();
                            activeElement.parent('ul').find(('.tooltip-description')).text(longtitle); //set rel to description box
                            activeElement.parent('ul').find(('.tooltip-description')).css('top', (topPos.top + 30)); //Position description box
                            activeElement.parent('ul').find(('.tooltip-description')).fadeIn(150); //Show description box
                        }
                    }
                }
            }

            //Timer, after 500m/s fire tooltip
            setTimeout(function () { showTip(activeElement) }, 500);
        });
        //Leave the hit zone
        $('.options li').mouseleave(function () {
            mouseInside = false; //Not over
            $(this).parent('ul').find(('.tooltip-description')).fadeOut(150); //Show description box
        });
    }

    /* --------------------------------
    Filter Hover Show()
    -------------------------------- */
    $('.filter').mouseover(function () {
        $(this).css('overflow', 'visible');
        $(this).children('ul').addClass('active');
    });
    $('.filter').mouseout(function () {
        $(this).css('overflow', 'hidden');
        $(this).children('ul').removeClass('active');
    });

    /* --------------------------------
    Filter (Jump to)
    -------------------------------- */
    //Global controls ( remember: there are 3 lots of the same re-used control)
    var filterItems = $('.qualification-builder .filter ul li');

    filterItems.click(function () {
        var relatedGroup = $(this).parents('.drag-drop-module').find('.options').children('.group');
        var thumb = $(this).parents('.drag-drop-module').find($('.thumb'));
        var categoryPosition = relatedGroup.eq($(this).index()).position();
        var topVector = categoryPosition.top * -1;
        var topVectorAbs = categoryPosition.top;
        var containerHeight = parseInt($(this).parents('.drag-drop-module').find($('.overview')).css('height'));
        var asPercenage = ((topVectorAbs / containerHeight) * 100); //As percentage
        var check = (asPercenage / 210) * 100;
        var percentageIncrease = asPercenage - check;
        var percentageToPx = (percentageIncrease / 100) * 352;

        $('.overview').animate({
            top: topVector
        });
        $(this).parents('.drag-drop-module').find($('.thumb')).animate({
            top: percentageToPx + "px"
        });

    });


    /* --------------------------------
    Document Stitching
    -------------------------------- */
    //Retrieves the unit IDs from the selected items, sent via AJAX to the document stitching.
    $('.download-spec').click(function () { //Click download

        var chosenIDs = [],
                        chosenOptions = $(this).parents('.drag-drop-module').find('.chosen-options ol'),
                        chosenOptionsCount = $(this).parents('.drag-drop-module').find('.chosen-options ol').children('li').length,
                        categoryID,
                        unitID;


        for (var i = 0; i < chosenOptionsCount; i++) {
            categoryID = chosenOptions.children('li').eq(i).attr('id');
            unitID = categoryID.split('_')[1];
            chosenIDs[i] = unitID;
        }

        //add units codes
        var handler = '/handlers/ilm/QualificationSpecDownloader.ashx';
        var url = handler + "?ids=";
        url += encodeURIComponent(chosenIDs.toString());

        //get parts codes
        var selectedPartsArr = $(this)
            .siblings('.chosen-options')
            .find('.checkboxes-selected span.checked')
            .map(function() {
                return $(this).next().val();
            });

        if (selectedPartsArr.length > 0) {
            //get partA|B
            url += '&parts=' + selectedPartsArr.get().join('|');
        }

        var productId = $(this).next().val();
        url += '&pId=' + productId;

        url += '&wk=' + $('#TimeStampUtc').val();
        $('#doc-stitch').attr('src', url);

        var countTest = 0;
        var watingTimeOut = setTimeout(function () {
            countTest++; // increment of maximun number of calls to wait
            documentCall();
        }, 3000);

        //hide download button until document returns
        var downloadSpecButton = $(this);
        downloadSpecButton.hide();
        $('<a class=\"cta download-spec-waiting\">' + downloadSpecButton.text() + '</a>').insertAfter($('.download-spec'));
        function documentCall() {
            $.ajax({
                url: '/handlers/ilm/QualificationSpecDownloaderTimer.ashx?wk=' + $('#TimeStampUtc').val(),
                async: true,
                success: function (data) {
                    //console.log(data);
                    if (data == 'True') {
                        downloadSpecButton.show();
                        $('.download-spec-waiting').remove();
                    } else {
                        if (countTest < 100) {
                            documentCall();
                        }
                    }
                }
            });
        }

    });

    openQualificationBuilder();
    
} //end qualification builder

/* --------------------------------------- */

function forceLoginMode() {
    $('.login-register').show();
    var whiteMaskTop = $('.site-header').position().top + parseInt($('.login-register').css('margin-top'));
    var cookieAjaxTimeout = setTimeout(function () {
        if ($('.cookie-module').length) { //if cookie module on display
            $('.white-mask').height($(document).height() - 344);
            $('.white-mask').css('top', $('.cookie-module').outerHeight() + whiteMaskTop);
        } else {
            $('.white-mask').height($(document).height() - 251);
            $('.white-mask').css('top', whiteMaskTop);
        }
        $('.white-mask').show();
    }, 50);
};

/* ==============================
Partial post backs
============================== */

function pageLoad() {
    try {
        RemoveDuplicateFormEntries();
    } catch (e) { }
    
        
    /* Comment form lightbox */
//    $('.comment-form-show').click(function () {
//        //move cta text() to lightbox <h3>
//        var buttonText = $(this).text();
//        $('.comment-lightbox').children().children('h3').text(buttonText);
//        $('.comment-lightbox').fadeIn(600);
//        $('.lightbox-bg').fadeIn(600);
//        return false;
//    });
    
    //Close
    $('.lightbox-bg, .lightbox .close').click(function (e) {
        if (e.target === this) {
            $('.lightbox').fadeOut(600);
            $('.lightbox-bg').fadeOut(600, function () {
                var urlHere = window.location;
                window.location.href = urlHere;
            });
        }
    });
    
	/* || Postback Handling || */
    var isPostback = $('.postback-hidden input').val();
	if (isPostback == "true") { //If postback is true
		runWebFormsConstructor();
    }

//Comments lightbox show thanksyou page
var isCommentPostback = $('.comments-postback-hidden').val();
if (isCommentPostback == "true") { //If postback is true
    //runWebFormsConstructor();
    $('.comment-lightbox').show();
    $('.lightbox-bg').show();
}

	/* ================================
	   Select and Checkbox Styling
	   ================================ */
    var counter = 0;
	/* select box styling for member update top area form*/
	if ($('div.dropdown-widget-forms, div.dropdown-widget, div.scfDropListGeneralPanel, div.dropdown, .scfDateSelectorGeneralPanel').length) {
		$('div.dropdown-widget-forms, div.dropdown-widget, div.scfDropListGeneralPanel, div.dropdown, .scfDateSelectorGeneralPanel').each(function (index) {
		    //Date selector 
            if($(this).hasClass('scfDateSelectorGeneralPanel')) {
                $(this).find('select').each(function() {
                    var thisElement = $(this);
                    //set up markup for custom selects
                    $('<div class="custom-date-dropdown dropdown-widget"></div>').insertBefore($(this));
                    $(this).prev('.custom-date-dropdown').append(thisElement);
                });
                    
                $(this).find('.custom-date-dropdown').each(function() {
			        // create span and set the text to the current selected text
	                $(this).prepend('<span style="position: absolute;" class="styled-dropdown"><span class="dropdown-inner">' + $(this).find('select option:selected').text() + '</span></span>');

			        //set select box to transparent
			        $(this).find('select').css({ 'opacity': 0, 'position': 'absolute' });

                    // focus indicator
                    $(this).find('select').bind('focus', function(e) {
                        $(this).prev('.styled-dropdown').addClass('focus');
                    });
                    $(this).find('select').bind('blur', function(e) {
                        $(this).prev('.styled-dropdown').removeClass('focus');
                    });

			        //change event handler sets the text to the updated selected text
                    $(this).find('select').bind('change keyup', function(e) {
	                    $(this).parent().find('span span').html($(this).find('option:selected').text());
			        });
                });

            } else {

                // create span and set the text to the current selected text
               // $(this).prepend('<span style="position: absolute;" class="styled-dropdown">' + $(this).find('select option:selected').text() + '</span>');

                //set select box to transparent
               // $(this).find('select').css({ 'opacity': 0, 'position': 'absolute' });

                // focus indicator
                $(this).find('select').bind('focus', function(e) {
                    $(this).prev('.styled-dropdown').addClass('focus');
                });
                $(this).find('select').bind('blur', function(e) {
                    $(this).prev('.styled-dropdown').removeClass('focus');
                });

                //change event handler sets the text to the updated selected text
                $(this).find('select').bind('change keyup', function(e) {
                    $(this).parent().find('span').html($(this).find('option:selected').text());
                });
            }
	    });
	}

    /* checkbox styling (simple) */
	if (!$('.qw-members-join').length) {
	    if ($('div.check-widget-forms, span.scfCheckbox').length) {
	        $('div.check-widget-forms, span.scfCheckbox').each(function (index) {
	            // create span and set the class to the current selected state
	            var cssClass = $(this).find('input[type=checkbox]:checked').length === 1 ? "checked" : "";
	            $(this).prepend('<span style="position: absolute;" class="' + cssClass + '"></span>');

	            //set select box to transparent
	            //$(this).find('input[type=checkbox]').css({ 'opacity': 0, 'position': 'absolute' });

	            //change event handler sets the text to the updated selected text
	            $(this).find('input[type=checkbox]').change(function () {

	                $(this).parent().find('span').toggleClass('checked');
	                // isChecked($(this));
	                $('#fader-button').removeClass('transparent50');
	            });
	        });
	    }

	    /* checkbox styling (Complex) */
	    if ($('.scfCheckBoxListGeneralPanel').length) {
	        $('.scfCheckBoxListGeneralPanel').each(function (index) {

	            $(this).find('td').each(function (i) {
	                if ($(this).children('input').length) {
	                    var cssClass = $(this).find('input[type=checkbox]:checked').length === 1 ? "checked" : "";
	                    $(this).prepend('<span style="position: absolute;" class="' + cssClass + '"></span>');
	                    $(this).children('input').css('opacity', '0'); // set opacity of checkbox to 0 to ensure it is hidden
	                }

	                // added toggleclass checked for this case
	                $(this).children('input[type=checkbox]').change(function () {
	                    $(this).parent().children('span').toggleClass('checked');
	                });
	            });

	            //$(this).find('input[type=checkbox]').css('display', 'none');
	            $('.my-profile.cf').off('click').on('click', 'td span', function () {
	                var span = $(this).parent('td').find('span');
	                var input = $(this).parent('td').find('input[type=checkbox]');

	                if ($(input).is(':checked')) {
	                    $(input).removeAttr('checked');
	                } else {
	                    $(input).attr('checked', 'checked');
	                }

	                $(span).toggleClass('checked');
	            });

	            $(this).find('input[type=checkbox]').bind('focus', function () {
	                $(this).prev('span').addClass('focus');
	            });
	            $(this).find('input[type=checkbox]').bind('blur', function () {
	                $(this).prev('span').removeClass('focus');
	            });
	        });
	    }
	}
	/* ================================ <End Select & Checkbx Styling> ================================ */

	/* ================================
	Custom Clientside Validation
	================================ */
	/* Validation Plug-in Description */
	// Available validation types: Required field | Email Regex (Only one per field)
	// On submit of the master submit or blur of the input (if still invalid) the function
	// retrieves the value, compares it to an algorithm based on the data-validate attr chosen.
	// Following analysis the function assigns the error class to the parent element, of which the children
	// are css styled. The error messages for each format of validation are displaid based on the validation format
	// which is assigned in each function during the analysis stage

	/* || Global Vars || */
	var thisForm,
			emailRegEx,
			watermarks, //Watermarks in any inputs, for required checker
			validationFormat, //Variable to determine the validation format, (required/invalid)
			fieldValue, //Value of the field
			validationType, //data-validate attribute for each input element
			onceFailed = false, //If ASP server error check has occurred atleast once, this is set true
			submitDisabled,
			isValid = false; //Valid state variable


    /* || RESULTANT ACTION FUNCTIONS || */

    //Validation Checker
	function validationCheck(linkObj, isValid, validationFormat) {
	    //hide asp validations, they will be shown again after post back
	    linkObj.parents('.fieldset').children('div.asp-server-error').hide();
	    
        switch (isValid) {
            case true: //"False," as in valid
                //Remove error class
                linkObj.parents('.field').removeClass('error');
                switch (validationFormat) {
                    //Required error message show()    
                    case 'required':
                        linkObj.parents('.field').find('.required').fadeOut(250);
                        break;

                    case 'invalid':
                        //Invalid error message show()
                        linkObj.parents('.field').find('.invalid').fadeOut(250);
                        break;

                    case 'other':
                        //Other error message show() ADD MORE HERE
                        break;
                }
                break;
            case false: //"False," as in failed validation
                //Remove error class
                linkObj.parents('.field').addClass('error');
                switch (validationFormat) {
                    //Required error message show()  
                    case 'required':
                        linkObj.parents('.field').find('.required').fadeIn(250);
                        break;

                    case 'invalid':
                        //Invalid error message show()
                        linkObj.parents('.field').find('.invalid').fadeIn(250);
                        break;

                    case 'other':
                        //Other error message show() ADD MORE HERE
                        break;
                }
                break;
        }

    };

    /* || VALIDATION TYPE ANALYSIS || */

    // Analyses which type of validation is required, based on attached classes to input elements
    function validate(linkObj) {
        if (onceFailed) { // If ASP server error has occurred at least once and user is going for the resubmit, hide warning (stops overlap of messages ultimately)
            $('.asp-server-error').fadeOut();
        };
        thisForm = linkObj.parents('.forms > div');
        //Find all inputs and assess the validation required
        thisForm.find('input').each(function () {
            validationType = $(this).attr('data-validate'); //Find out validation type
            fieldValue = $(this).val(); //Get the field value for analysis
            switch (validationType) {
                //CASE REQUIRED  
                case 'required':
                    validationFormat = "required";   //The format for validation (to determine which error message to show)
                    if (fieldValue == "" || fieldValue == null || fieldValue == "Password") {//If empty or null
                        isValid = false;
                    }
                    else {
                        isValid = true;
                    }
                    validationCheck($(this), isValid, validationFormat); // Pass the results to actions function
                    break;
                //CASE EMAIL REGEX      
                case 'email':
                    validationFormat = "invalid";   //The format for validation (to determine which error message to show)
                    emailRegEx = /^[a-zA-Z0-9_-]+(?:\.[a-zA-Z0-9_-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?$/; //The alorithm
                    isValid = emailRegEx.test(fieldValue);  //The test
                    validationCheck($(this), isValid, validationFormat);  //Pass results to actions function
                    break;

                case 'bpNoOrEmail':
                    validationFormat = "invalid";   //The format for validation (to determine which error message to show)
                    var pattern = new RegExp(/^[0-9]{6,10}$|^[a-zA-Z0-9_-]+(?:\.[a-zA-Z0-9_-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?$/); //The algorithm
                    isValid = pattern.test(fieldValue);  //The test
                    validationCheck($(this), isValid, validationFormat);  //Pass results to actions function
                    break;

                case 'custom':
                    //Some custom reg ex
                    break;
            }

        });

    }

    /* || Triggers || */
    //Submit
    $('.forms.custom-validator .submit').click(function (e) {
        if (!submitDisabled) {//If not already disabled
            validate($(this));
            // and no client-side errors, permit the submit
            if (!$('.forms.custom-validator .field').hasClass('error')) {
                submitDisabled = true;
                $('.login-register .processing').fadeIn(); //Start GIF, hand over to server -->
            }
        }
        else {
            e.preventDefault();
        }

    });

    //Blur
    $('.forms.custom-validator input').blur(function () {
        if ($('.forms.custom-validator .field').hasClass('error')) { //Only if invalid (submitted and failed at least once, or is still invalid)
            validate($(this));
        };
        if (onceFailed) {
            submitDisabled = false;
            $('.forms.custom-validator .submit').removeClass('disabled');
        };
    });

    //enter keypress
    $('.RadEditor .reContentArea').keypress(function(ev) {
        if (ev.keyCode == 13) {
            ev.preventDefault();
        } else {
            console.log("test");
        }
    });

    $('.custom-validator input').keypress(function (ev) {
        if (ev.keyCode == 13) {
            $('.custom-validator .submit').click(); //fire client side validation
            window.location.href = $(this).parents('.custom-validator').find('.cta.submit').attr('href'); // if passes, manually force server postback
        }
    });
  
    // binding enter to submit html forms when on a textarea in the form
    $(".search input[type=text]").keypress(function (ev) {
        if (ev.keyCode == 13) {
            $(this).next(".search-button-go").click();
        }
    });
    $(".search-area input[type=text]").keypress(function (ev) {
        if (ev.keyCode == 13) {
            $(this).next(".cta").click();
        }
    });
    $(".filter input[type=text]").keypress(function (ev) {
        if (ev.keyCode == 13) {
            window.location.href = $(".filter .cta a.button-submit").attr('href');
        }
    });
    // qualification finder and home pages
    $(".widget-forms input[type=text]").keypress(function (ev) {
        var button = $(this).parents('.widget-forms').find('.geo-code-search');
        if (ev.keyCode == 13) {
            if ($(this).val() == '' || $(this).val() == 'Post code') {
                button.click();
            } else {
                if ($('.widget-forms .error').length == 0) {
                    button.addClass('clicked');
                    getGeoCode($(this).val(), $('input.geocode-container'));
                }
            }
        }
    });
    $('.tabberItem input.postcode').keypress(function(ev) {
        var button = $(this).parents('.tabberItem').find('.geo-code-search');
        if (ev.keyCode == 13) {
            if ($(this).val() == '') {
                button.click(); // run click validation only if field is empty
            } else {
                button.addClass('clicked');
                getGeoCode($(this).val(), $('input.geocode-container'));
            }
        }
           
    });
    /*$("#homepage .widget-forms input[type=text]").keypress(function (e) { // home page one
        if (e.keyCode == 13) {
            $(".widget-forms .geo-code-search").click();
        }
    });*/
        
    /* || Fail All Exception || */
    //Caution: ensure all vairables are updated
    function failAll() {
        $('.forms.custom-validator .field').addClass('error'); //Linked variable is ALL fields Input elements
        $('.asp-server-error').fadeIn();
    }

    /* || Postback Handling || */
    var isPostback = $('.postback-hidden input').val();
   
    if (isPostback == "true") { //If postback is true
        submitDisabled = true;
       
        onceFailed = true;
        $('.login-register, .my-profile').show(); //Stop the element from collapsing
        $('.forms.custom-validator .submit').addClass('disabled');
        $('.login-register .processing').css('display', 'block');
        $('.login-register .processing').fadeOut();
        //Stop processing GIF


        //Set all to failed, (email combo failure)
        failAll(); //This will cause the reset password to also become failed, configure failAll() to target login details only if required


    }


    /* ================================
    Prepopulate Regions
    ================================ */

    //bottom forms
    $('#page').on('change', 'div.step-loader .name\\.Home\\+Country select', function () {
        var countryCode = $(this).val();
        populateSelectList("/handlers/ilm/formlists/regions.ashx", 'div.step-loader .name\\.Home\\+County select', { countryCode: countryCode });
    });

    $('#page').on('change', 'div.step-loader .name\\.Home\\+County select', function () {
        var regionCode = $(this).val();
        $('div.step-loader input#HomeHiddenCounty').val(regionCode);
    });

    $('#page').on('change', 'div.step-loader .name\\.Work\\+Country select', function () {
        var countryCode = $(this).val();
        populateSelectList("/handlers/ilm/formlists/regions.ashx", 'div.step-loader .name\\.Work\\+County select', { countryCode: countryCode });
    });

    $('#page').on('change', 'div.step-loader .name\\.Work\\+County select', function () {
        var regionCode = $(this).val();
        $('div.step-loader input#WorkHiddenCounty').val(regionCode);
    });
    /* ================================
    End Prepopulate Regions
    ================================ */

    /*User Profile widget edit link*/
    $('div.profile-widget div.button a').click(function (ev) {
        ev.preventDefault();
        $('div.my-profile-tab span.profile-label').click();
    });

    /* Twitter Widgets */
    if ($('.twitter-segment').length) {
        //twitter init timer
        var initTimer = setTimeout(function () {
            twitterWidgetStyling();
            $('.twitter-segment .inner-content .loading').fadeOut(200, function () {
                $('.twitter-segment .twitter-module').fadeIn(250); //show when ready
            });

        }, 3000);
        setTimeout(twitterWidgetStyling, 4000);
        setTimeout(twitterWidgetStyling, 5000);
    }

    //AT WebMethods

    var deleteFromAzure = function (e) {
        var $self = $(this);
        var ajaxData = {
            FileName: $self.attr('value')
        };
        $.ajax({
            type: "POST",
            url: "/WebServices/AzureService.svc/DeleteFile",
            data: JSON.stringify(ajaxData),
            contentType: "application/json; charset=utf-8",
            dataType: "json",
            success: function (response) {
                if (response.Success) {
                    $self.parent().html('<div style="color:#ed1f24;"><span style="float:left;"> ' + response.Message.split(response.Message.charAt(response.Message.length - 7))[0]
                        + '</span><span style="float:right;margin-right:1px;">deleted</span></div>').delay(1000).animate({ 'height': '0px', 'padding': '0' }, 500, function () {
                            $(this).remove();
                        });
                }
            }
        });
    };
    $('.delete-upload-file').click(deleteFromAzure);

} //end pageLoad()

function twitterWidgetStyling() {
    $(".lower-rail .twitter-segment .twitter-module iframe").contents().find(".stream").css('height', '158px');
    $(".right-rail .twitter-segment .twitter-module iframe").contents().find(".stream").css('height', '158px');
    $("#homepage .twitter-segment .twitter-module iframe").contents().find(".stream").css('height', '154px');
    $(".twitter-segment .twitter-module iframe").contents().find(".timeline-header, .timeline-footer").css('display', 'none');
    //            $(".twitter-segment .twitter-module iframe").contents().find(".timeline-footer").css('display', 'none');
    $(".twitter-segment .twitter-module iframe").contents().find(".timeline").css('background', 'transparent');
    $(".twitter-segment .twitter-module iframe").contents().find(".timeline").css('border', 'none');
    $(".twitter-segment .twitter-module iframe").contents().find(".stream, .tweet a").css('color', '#fff');
    $(".twitter-segment .twitter-module iframe").contents().find(".tweet").css('padding', '1px 0 0 0');
    $(".twitter-segment .twitter-module iframe").contents().find(".stream").css('overflow', 'hidden');
    $(".twitter-segment .twitter-module iframe").contents().find(".load-more, .full-name").remove();

    //remove all but latest
    var latestTweet = $(".twitter-segment .twitter-module iframe").contents().find(".h-feed li").eq(0);
    $(".twitter-segment .twitter-module iframe").contents().find(".h-feed li").remove();
    $(".twitter-segment .twitter-module iframe").contents().find(".h-feed").append($(latestTweet));
    $(".twitter-segment .twitter-module iframe").contents().find(".h-feed li").css('border', 'none');
    $(".twitter-segment .twitter-module iframe").contents().find(".u-photo").attr('src', '/images/ILM Website/twitter-bird.gif');
    $(".twitter-segment .twitter-module iframe").contents().find(".u-photo").css('background', 'transparent');
    $(".twitter-segment .twitter-module iframe").contents().find(".e-entry-content").css('margin-top', '10px');
    $(".twitter-segment .twitter-module iframe").contents().find(".e-entry-title").css('font-size', '13px');
    
    $(".twitter-segment .twitter-module iframe").contents().find(".tweet .header .p-nickname").css({
        'position': 'absolute',
        'top': navigator.userAgent.toLowerCase().indexOf('firefox') > -1 ? '5px' : '-10px',
        'left': '45px',
        'font-size': '18px'
    });
    $(".oldie .twitter-segment .twitter-module iframe").contents().find(".tweet .header .p-nickname").css('top', '0px');

    if (isIE) {
        if (isIE8) {
            $(".twitter-segment .twitter-module iframe").contents().find(".h-feed").css('padding-top', '5px');
        } else {
            $(".twitter-segment .twitter-module iframe").contents().find(".h-feed").css('padding-top', '15px');
        }
    }
}
//Remove duplicate entries in multistep forms
function RemoveDuplicateFormEntries() {
    if ($('div#content div.step-loader input#HomeHiddenCounty').length > 1) {
        $('div#content div.step-loader input#HomeHiddenCounty').first().remove();
        $('div#content div.step-loader input#HomeHiddenCounty').parent('div.scfDropListGeneralPanel').find('select').last().remove();
    }
    if ($('div#content div.step-loader input#WorkHiddenCounty').length > 1) {
        $('div#content div.step-loader input#WorkHiddenCounty').first().remove();
        $('div#content div.step-loader input#WorkHiddenCounty').parent('div.scfDropListGeneralPanel').find('select').last().remove();
    }
}


/* ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ */
/* --------------------------
Populate Region dropdowns
----------------------------- */
function populateSelectList(url, target, params) {
    $.getJSON(
            url,
            params,
            function (data) {
                var select = $(target);
                select.empty();
                $.each(data, function (index, itemData) {
                    if (index == 0)
                        itemData.Selected = "Selected";
                    select.append($('<option/>', { value: itemData.Value, text: itemData.Text, selected: itemData.Selected }));
                }); //end each

                if (select.prev().is('span')) {
                    select.prev().html('');
                    select.parent('div').children('input[type=hidden]').val('');

                    var firstOption = select.children('option:first-child');
                    if (firstOption != null || typeof (firstOption) == 'undefined') {
                        select.prev().html(firstOption.html());
                        select.parent('div').children('input[type=hidden]').val(firstOption.val());
                    }

                }
            });        //end getJSON
};

/* --------------------------
Form clear on focus REMOVED MON 28/11/12 (CAUSING CONFLICTS WITH WEB FORMS)
----------------------------- */
function setInputClear() {
    $defaultVal = '';
    $('.oldie input[type="text"]').each(function (index) {
        $defaultVal = $(this).val();
        $(this).attr("data-defaultValue", $defaultVal);
    });
    $('.oldie input[type="text"]').focus(function () {
        $defaultVal = $(this).attr("data-defaultValue");
        if ($(this).val() == $defaultVal) {
            $(this).val('');
        }
    });
    $('.oldie input[type="text"]').blur(function () {
        if ($(this).val() == '') {
            $(this).val($defaultVal);
        }
    });
}

setInputClear();

function searchInputFieldClear() {
    $defaultVal = '';
    $('input[type="text"].autocomplete').each(function (index) {
        $defaultVal = $(this).val();
        $(this).attr("data-defaultValue", $defaultVal);
    });
    $('input[type="text"].autocomplete').focus(function () {
        $defaultVal = $(this).attr("data-defaultValue");
        if ($(this).val() == $defaultVal) {
            $(this).val('');
        }
    });
    $('input[type="text"].autocomplete').blur(function () {
        if ($(this).val() == '') {
            $(this).val($defaultVal);
        }
    });
}
searchInputFieldClear();

function ForceBlurOfGeoCodeTarget() {
    if (jQuery('input.geocode-container').val().length <= 0) {
        jQuery('input.geocode-target').blur();
    }
    return true;
}

/* -----------------------------
Centre Finder Postcode Required 
-------------------------------- */
$('.postcode-submit .button').click(function (e) {
    var thisPostcodeInput = $(this).parents('.forms').find('.required-postcode .postcode');
    if (thisPostcodeInput.val() == "") {
        thisPostcodeInput.parent().addClass('error');
        e.preventDefault();
    }
});
$('.required-postcode input').blur(function () {
    if ($(this).val() != "") {
        $(this).parent().removeClass('error');
    }
    else {
        if ($(this).parent().children('.error-message').css('display') == "inline") {
            $(this).parent().addClass('error');
        }
    } 
});
// validation for home page and qualification finder page location forms
$('.widget-forms .geo-code-search').click(function (e) {
    var thisPostcodeInput = $(this).parents('.widget-forms').find('.required-postcode .postcode');
    $(this).parents('.widget-forms').find('select').each(function () {
        if ($(this).val() == -1) {
            $(this).parents(".dropdown-widget-forms").addClass('error');
            e.preventDefault();
        }
    });
    if (thisPostcodeInput.val() == "Post code" || thisPostcodeInput.val() == "") {
        thisPostcodeInput.parent().addClass('error');
        e.preventDefault();
    }
    /*if (!$('.widget-forms .error').length) {
        window.location.href = $(this).attr('href'); // force geocode search
    }*/
});
$('.widget-forms .required-postcode .postcode').keyup(function () {
    if ($(this).val() !== "Post code" && $(this).val() !== "") {
        $(this).parent().removeClass('error');
    }
});
$('.widget-forms .dropdown-widget-forms').click(function () {
    if ($(this).find("select").attr('value') !== -1) {
        $(this).removeClass("error");
    }
});



// Google Maps
function initializeMap() {
    var latlng = new google.maps.LatLng(51.53753, -0.096904);
    var opts = {
        center: latlng,
        zoom: 16,
        mapTypeId: google.maps.MapTypeId.ROADMAP
    };

    var map = new google.maps.Map(document.getElementById("map_canvas"), opts);
    var markerpoint = new google.maps.MarkerImage(
		'../img/marker-pin.png',
		new google.maps.Size(25, 37),
		new google.maps.Point(0, 0),
		new google.maps.Point(13, 37)
	);

    var marker = new google.maps.Marker({
        position: latlng,
        map: map,
        icon: markerpoint,
        title: "JHP Academy"
    });

    var infowindow = new google.maps.InfoWindow({
        content: '<b>JHP Academy</b><br /> 35 Britannia Row <br />Islington <br />N1 8QH'
    });

    google.maps.event.addListener(marker, 'click', function () {
        infowindow.open(map, marker);
    });
}

var lock = false;
function getGeoCode(address, geocodeContainer, event) {
    var geocoder = new google.maps.Geocoder();

    if (geocoder) {
        blockGeoSearch = true;
        geocoder.geocode({ 'address': address, 'region': 'uk' }, function (results, status) {
            blockGeoSearch = false;
            if (status == google.maps.GeocoderStatus.OK && !lock) {
                geoCodeSuccess = true;
                geocodeContainer.val(results[0].geometry.location);

                if (event !== "undefined" && event.which === 13) {
                    document.getElementById('btnFindCentre').click();
                } else {
                    $('.geo-code-search.clicked').each(function () {
                        $(this)[0].click();
                    });
                }

                lock = true;
            }
            else {
                geoCodeSuccess = false;
                lock = false;
            }
        });
    }
    else {
        geoCodeSuccess = false;
    }
};

function trackEvent(category, action, label) {
    _gaq.push(['_trackEvent', category, action, label]);
};

function openQualificationBuilder() {
    /*reopen qualification builder after login*/
    if (typeof isCallAfterLogin !== 'undefined' && isCallAfterLogin) {
        $('.qual-builder').click();
        isCallAfterLogin = false;
    }
};

// breadcrumb related
$(".breadcrumb li.active a").removeAttr("href");

// site search, toggle filters on click
jQuery(document).ready(function ($) {
    $('.search-result-more-container').hide();

    $('.search-result-more a').bind('click', function (e) {
        e.preventDefault();
        $(this).toggleClass('search-result-more-is-open');
        $('.search-result-more-container').slideToggle(200);
    });

    if ($('.search-result-more-container .active-filter').length) {
        // if there are active filters within the 'more' list
        // then toggle click
        $('.search-result-more a').toggleClass('search-result-more-is-open');
        $('.search-result-more-container').slideToggle(200);
    }
});

$(document).on("click", '.resource__info', function(e) {
    e.preventDefault();
    $(this).siblings('.resource__image').slideToggle(300);
    $(this).next('.resource__description').toggleClass('open');
    $(this).find('.more').toggleClass('active');
    $(this).find('.less').toggleClass('active');
});

$(document).on("click", '.search-products__submit, .search-products__clear, .resource__load-more', function (e) {
    e.preventDefault(); 
});

window.onkeydown = function (event) {
    if (event.which === 13) {
        var FormElements = [
            "selParticitpantTypes",
            "selProviderType",
            "txtPostCode"]

        var ActiveId = document.activeElement.id;

        if (FormElements.indexOf(ActiveId) > -1) {
            getGeoCode(document.getElementById("txtPostCode").value, $("input.geocode-container"), event);
        }
    }
}